(function ($, window, document) {
    const $window = $(window);

    const initSlick = ($sliders, additionalOptions) => {
        $sliders.each((index, slider) => {
            const $slider = $(slider);
            const $dots = $slider.find(".slider__paging");
            const $sliderContainer = $slider.find(".slider__slides");

            $sliderContainer.slick({
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                appendDots: $dots,
                appendArrows: $slider.find(".slider__actions"),
                prevArrow: $slider.find(".slider__prev"),
                nextArrow: $slider.find(".slider__next"),
                ...additionalOptions,
            });
        });
    };

    initSlick($(".js-slider-images"), {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        addaptiveHeight: false,
        fade: true,
    });

    let $fixedElement = $(".js-fixed-on-scroll");
    let additionalSpace = $fixedElement.data("offset") || 0;
    let $fixedElementChild = $(".js-fixed-element");
    let headerHeight = $(".header__bar").outerHeight();
    let fixedElementOffsetTop, fixedElementH, fixedElementChildH;

    $window.on("resize load scroll", function () {
        if ($fixedElement.length) {
            fixedElementOffsetTop = $fixedElement.offset().top;
            fixedElementH = $fixedElement.outerHeight();
            fixedElementChildH = $fixedElementChild.outerHeight();

            let scroll = $(this).scrollTop();

            if (scroll > fixedElementOffsetTop && $window.width() > 1022) {
                $fixedElement.addClass("is-fixed");
                $fixedElementChild.width($fixedElement.outerWidth());
            } else {
                $fixedElement.removeClass("is-fixed");
                $fixedElementChild.width("auto");
            }

            if (
                scroll >
                    fixedElementOffsetTop +
                        fixedElementH -
                        additionalSpace -
                        fixedElementChildH &&
                $window.width() > 1022
            ) {
                $fixedElement.addClass("at-bottom");
            } else {
                $fixedElement.removeClass("at-bottom");
            }
        }
    });

    function changeLiTags() {
        var $liElements = $(".js-image-logos li");
        var currentIndex = 0;

        $liElements.eq(currentIndex).addClass("is-active");

        function changeNextLi() {
            $liElements.removeClass("is-active");

            $liElements.eq(currentIndex).addClass("is-active");

            currentIndex = (currentIndex + 1) % $liElements.length;
        }

        setInterval(changeNextLi, 1000);
    }

    changeLiTags();

    function addIsFilledOnScroll() {
        var $header = $(".header__bar");
        var $listProcessItems = $(".list-process li");

        $window.on("scroll", function () {
            var headerBottom = $header.offset().top + $header.outerHeight();

            var scroll = $(this).scrollTop();

            $listProcessItems.each(function () {
                var $this = $(this);
                var elementTop = $this.offset().top;

                if (headerBottom + $header.outerHeight() >= elementTop) {
                    $this.addClass("is-filled");
                } else {
                    $this.removeClass("is-filled");
                }
            });
        });
    }

    addIsFilledOnScroll();

    $(".js-scroll-to-section").on("click", function (e) {
        e.preventDefault();

        let href = $(this).attr("href");
        let href_split = href.split("#");
        if (href_split.length == 0 || href_split[1] == "") {
            return;
        }

        let $target = $("#" + href_split[1]);
        if ($target.length == 0) {
            return;
        }

        $("html, body").animate(
            {
                scrollTop:
                    $target.offset().top - $(".header__bar").outerHeight(),
            },
            1000
        );
    });

    $('.section--multi-select input[type="checkbox"]').on(
        "change",
        function () {
            let thisElement = $(this);
            let label = thisElement
                .parents(".section--multi-select")
                .eq(0)
                .find(".gfield_label");
            let selectedValues = thisElement
                .closest(".ginput_container")
                .find("input:checked")
                .map(function () {
                    return this.value;
                })
                .get();
            if (selectedValues.length > 0) {
                label.text(selectedValues.join(", "));
            } else {
                label.text(label.data("original-text"));
            }
        }
    );

    /**
     * Init slider thumbnails.
     *
     * @param {JQuery|HTMLElement} slider
     * @returns {Void}
     */
    const initSliderThumbnails = (_, slider) => {
        const $slider = $(slider);
        const speed = 600;
        const autoplaySpeed = 4000;
        const options = {
            infinite: true,
            speed: speed,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            fade: true,
            autoplay: true,
            autoplaySpeed: 4000,
        };

        /**
         * Add image to control.
         *
         * @param {HTMLElement} dot
         * @returns {Void}
         */
        const addImageToControl = (_, dot) => {
            const $dot = $(dot);
            const slideId = $dot.attr("aria-controls");
            const $slide = $slider.find(`#${slideId}`);
            const $slideImage = $slide.find(".slide__image picture");
            const caption = $slide.data("caption");

            $dot.html($slideImage.clone())
                .closest("li")
                .attr("data-caption", caption);
        };

        /**
         * Handle init.
         *
         * @param {Slick} slick
         * @returns {Void}
         */
        const handleInit = (_, slick) => {
            setTimeout(() => {
                const $dots = $slider.find(".slick-dots button");
                $dots.each(addImageToControl);
            }, 1);
        };

        /**
         * Add slider speed and autoplay speed as css variables.
         * Add slick event handlers.
         * Init slick.
         */
        $slider
            .css({
                "--slider-speed": `${speed}ms`,
                "--slider-autoplay-speed": `${autoplaySpeed}ms`,
            })
            .on("init", handleInit)
            .slick(options);
    };

    /**
     * Init sliders thumbnails.
     *
     * @param {JQuery|HTMLElement[]} sliders
     * @returns {Void}
     */
    const initSlidersThumbnails = (sliders) => {
        const $sliders = $(sliders);
        $sliders.each(initSliderThumbnails);
    };

    /**
     * Init sliders thumbnails.
     */
    initSlidersThumbnails(".js-slider-thumbnails");
})($, window, document);
